<script>
import BotoesNavegacao from '@/components/BotoesNavegacao.vue'
import { fetchSponsor } from '@/utils/sponsor'

export default {
  components: { BotoesNavegacao },

  props: {
    sponsor: { type: Object, default: null },
  },

  data() {
    return {
      codigo: this.sponsor ? this.sponsor.indication : '',
      buscando: false,
      erro: '',
    }
  },

  methods: {
    async buscar() {
      const codigo = (this.codigo || '').trim()
      if (!codigo) {
        this.$toast.error('Informe o código do vendedor.')
        return
      }

      this.buscando = true
      this.erro = ''
      try {
        const data = await fetchSponsor(codigo)

        if (data.status === 'success' && data.user) {
          this.$emit('confirmar', data.user)
        } else {
          this.erro = data.message || 'Vendedor não encontrado. Confira o código e tente novamente.'
        }
      } catch (err) {
        this.erro = 'Erro de comunicação. Tente novamente.'
      } finally {
        this.buscando = false
      }
    },

    pular() {
      this.$emit('sem-vendedor')
    },
  },
}
</script>

<template>
  <div>
    <div v-if="sponsor && sponsor.name" class="alert alert--success" style="margin-bottom: 16px">
      Vendedor selecionado: <strong>{{ sponsor.name }}</strong>
    </div>

    <div class="form-row">
      <label class="field-label">Código</label>
      <input
        v-model="codigo"
        type="text"
        class="input"
        placeholder="Ex.: 12345678"
        autocomplete="off"
        :disabled="buscando"
        @keyup.enter="buscar"
      />
    </div>

    <div v-if="erro" class="alert alert--danger" style="margin-bottom: 16px">
      {{ erro }}
    </div>

    <BotoesNavegacao
      rotulo-voltar="Continuar sem vendedor"
      rotulo-avancar="Continuar"
      :carregando="buscando"
      @voltar="pular"
      @avancar="buscar"
    />
  </div>
</template>
